// src/api/axiosConfig.ts
import axios from 'axios';
import { useUserStore } from '@/stores/store.user';

//API Insecal
export const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  const userStore = useUserStore();
  const accessToken = await userStore.getToken;
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

//API Notifications
export const api_notificacion = axios.create({
    baseURL: import.meta.env.VITE_APP_API_NOTIFICACION_URL, 
});

api_notificacion.interceptors.request.use(async (config) => {
  const userStore = useUserStore();
  const accessToken = await userStore.getToken;
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});